import * as React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { AdminMedicineModel } from "../../models/medicine";
import ManufacturerService from '../../services/manufacturerService';
import { DropdownModel } from "../../models/dropdownModel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ActiveIngredientForAdminMedicineModel } from "../../models/activeIngredient";
import { InactiveIngredientForAdminMedicineModel } from "../../models/inactiveIngredient";
import AtcCodeService from '../../services/atcCodeService';
import { InputTextarea } from 'primereact/inputtextarea';
import { UnitType, DataSourceType, AuthorisationStatus } from '../../common/enums';
import { enumToDropdownArray } from '../../common/functions/helperFunctions';
import { ATCCodeModel } from '../../models/atcCode';

interface IProps {
	handleChange: any,
	medicine: AdminMedicineModel,
	removeActiveIngredientClick: any,
	removeInactiveIngredientClick: any,
	setIsVisibleActiveIngredientDialog: any,
	setIsVisibleInactiveIngredientDialog: any,
	setIsVisibleATCCodeListDialog: any,
	removeATCCodeClick: any,
	changeQuantity: any,
	getContentValue: any,
	handleContentChange: any,
	manufactorerName: string,
	authorisationHolderName: string,
	setIsVisibleManufactorerListDialog: any,
	setIsVisibleAuthorizationHolderListDialog: any,
	removeAuthorizationHolderClick: any,
	removeManufactorerClick: any
}

interface IState {
	manufacturerDropdown: Array<DropdownModel>;
	validationMessage: string;
	unitTypeDropdown: Array<DropdownModel>;
	dataSourceTypeDropdown: Array<DropdownModel>;
	authorizationStatusDropdown: Array<DropdownModel>;
	//atcDropdown: Array<DropdownModel>;
}

class MedicineTabBasicInfo extends React.Component<IProps, IState> {
	//atcCodeService = new AtcCodeService();
	manufacturerService = new ManufacturerService();

	constructor(props: IProps) {
		super(props);

		if (!props.medicine.manufacturerId) {
			props.medicine.manufacturerId = -1;
		}

		if (!props.medicine.activeIngredients) {
			props.medicine.activeIngredients = new Array<ActiveIngredientForAdminMedicineModel>();
		}

		if (!props.medicine.inactiveIngredients) {
			props.medicine.inactiveIngredients = new Array<InactiveIngredientForAdminMedicineModel>();
		}

		this.state = {
			validationMessage: '',
			manufacturerDropdown: Array<DropdownModel>(0),
			unitTypeDropdown: Array<DropdownModel>(0),
			dataSourceTypeDropdown: Array<DropdownModel>(0),
			authorizationStatusDropdown: Array<DropdownModel>(0)
			//atcDropdown: Array<DropdownModel>(0)
		};
	}

	componentDidMount() {
		this.initData();
	}

	initData() {
		const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
		this.setState({
			unitTypeDropdown: firstItem.concat(enumToDropdownArray(UnitType)),
			dataSourceTypeDropdown: firstItem.concat(enumToDropdownArray(DataSourceType)),
			authorizationStatusDropdown: firstItem.concat(enumToDropdownArray(AuthorisationStatus))
		});
		// this.manufacturerService.getDropdownList().then(
		// 	(data: Array<DropdownModel>) => {
		// 		const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
		// 		this.setState({
		// 			manufacturerDropdown: firstItem.concat(data),
		// 			unitTypeDropdown: firstItem.concat(enumToDropdownArray(UnitType)),
		// 			dataSourceTypeDropdown: firstItem.concat(enumToDropdownArray(DataSourceType)),
		// 			authorizationStatusDropdown: firstItem.concat(enumToDropdownArray(AuthorisationStatus))
		// 		});
		// 	})
		// 	.catch(error => {
		// 		this.setState({
		// 			//error
		// 		});
		// 	});
	}

	handleActiveIngredientAddNewClick() {
		this.props.setIsVisibleActiveIngredientDialog(true);
	}

	handleInactiveIngredientAddNewClick() {
		this.props.setIsVisibleInactiveIngredientDialog(true);
	}

	handleATCCodeAddEditClick() {
		this.props.setIsVisibleATCCodeListDialog(true);
	}

	handleATCCodeRemoveClick() {
		this.props.removeATCCodeClick();
	}

	handleQuantityChange = (activeIngredient: ActiveIngredientForAdminMedicineModel, value, key) => {
		this.props.changeQuantity(activeIngredient, value.value, key);
	}

	getTitle = (atcCode: ATCCodeModel) => {
		return atcCode.atcCodeContent && atcCode.atcCodeContent.length > 0 ? atcCode.atcCodeContent.map(r => r.atcCodeName).join(' / ') : null
	}

	handleManufacturerAddEditClick() {
		this.props.setIsVisibleManufactorerListDialog(true);
	}

	handleManufacturerRemoveClick() {
		this.props.removeManufactorerClick();
	}

	handleAuthorisationHolderAddEditClick() {
		this.props.setIsVisibleAuthorizationHolderListDialog(true);
	}

	handleAuthorisationHolderRemoveClick() {
		this.props.removeAuthorizationHolderClick();
	}

	public render() {

		const { manufacturerDropdown, unitTypeDropdown, dataSourceTypeDropdown, authorizationStatusDropdown } = this.state;
		const { medicine } = this.props;

		const atcCodeValue = (medicine.atcCode && medicine.atcCode.atcCode)
			? medicine.atcCode.atcCode + " / " +
			this.getTitle(medicine.atcCode)
			: "Select ATC Code";

		return (
			<div className="p-fluid p-grid p-md-12">
				<div className="p-col-12 p-md-3">
					<label>Brand Name:</label>
					<InputText
						name="brandName"
						onChange={(e) => this.props.handleContentChange('brandName', e.target['value'])}
						value={this.props.getContentValue("brandName")}
					/>
				</div>
				<div className="p-col-12 p-md-3">
					<label>Title:</label>
					<InputText
						name="additionalTitle"
						onChange={(e) => this.props.handleContentChange('additionalTitle', e.target['value'])}
						value={this.props.getContentValue("additionalTitle")}
					/>
				</div>
				<div className="p-col-12 p-md-3">
					<label>ИАЛ Number:</label>
					<InputText
						name="medicineNumber"
						onChange={(e) => this.props.handleChange('medicineNumber', e.target['value'])}
						value={medicine && medicine.medicineNumber ? medicine.medicineNumber : ""}
					/>
				</div>
				<div className="p-col-12 p-md-3">
					<label>EMA Number:</label>
					<InputText
						name="emaProductNumber"
						onChange={(e) => this.props.handleChange('emaProductNumber', e.target['value'])}
						value={medicine && medicine.emaProductNumber ? medicine.emaProductNumber : ""}
					/>
				</div>
				<div className="p-col-12 p-md-3 p-10">
					<label>Data source:</label>
					<Dropdown
						value={medicine && medicine.dataSourceTypeId ? medicine.dataSourceTypeId : -1}
						options={dataSourceTypeDropdown}
						onChange={(e) => this.props.handleChange('dataSourceTypeId', e.value)}
						style={{ width: '100%' }}
					/>
				</div>
				<div className="p-col-12 p-md-3 p-10">
					<label>Medicine data URL:</label>
					<InputText
						name="medicineDataURL"
						onChange={(e) => this.props.handleChange('medicineDataURL', e.target['value'])}
						value={medicine && medicine.medicineDataURL ? medicine.medicineDataURL : ""}
					/>
				</div>
				<div className="p-col-12 p-md-6">
					<label>Manufacturer:</label>
					<div className="p-inputgroup">
						<InputText
							readOnly={true}
							onClick={() => this.handleManufacturerAddEditClick()}
							value={this.props.manufactorerName}
						/>
						<Button
							icon="pi pi-plus"
							className="p-button-success"
							onClick={() => this.handleManufacturerAddEditClick()}
						/>
						<Button
							icon="pi pi-times-circle"
							className="p-button-warning"
							onClick={() => this.handleManufacturerRemoveClick()}
						/>
					</div>
				</div>
				<div className="p-col-12 p-md-6">
					<label>Authorisation Holder:</label>
					<div className="p-inputgroup">
						<InputText
							readOnly={true}
							onClick={() => this.handleAuthorisationHolderAddEditClick()}
							value={this.props.authorisationHolderName}
						/>
						<Button
							icon="pi pi-plus"
							className="p-button-success"
							onClick={() => this.handleAuthorisationHolderAddEditClick()}
						/>
						<Button
							icon="pi pi-times-circle"
							className="p-button-warning"
							onClick={() => this.handleAuthorisationHolderRemoveClick()}
						/>
					</div>
				</div>
				<div className="p-col-12 p-md-3 p-10">
					<label>Authorisation status:</label>
					<Dropdown
						value={medicine && medicine.authorisationStatusId ? medicine.authorisationStatusId : -1}
						options={authorizationStatusDropdown}
						onChange={(e) => this.props.handleChange('authorisationStatusId', e.value)}
						style={{ width: '100%' }}
					/>
				</div>
				<div className="p-col-12 p-md-12">
					<label>ATC Code:</label>
					<div className="p-inputgroup">
						<InputText
							readOnly={true}
							onClick={() => this.handleATCCodeAddEditClick()}
							value={atcCodeValue}
						/>
						<Button
							icon="pi pi-plus"
							className="p-button-success"
							onClick={() => this.handleATCCodeAddEditClick()}
						/>
						<Button
							icon="pi pi-times-circle"
							className="p-button-warning"
							onClick={() => this.handleATCCodeRemoveClick()}
						/>
					</div>
				</div>
				<div className="p-col-12 p-md-6">
					<label>Active Ingredients:</label>
					<div className="mb-2">
						<button
							onClick={() => this.handleActiveIngredientAddNewClick()}
							className="btn btn-success"
							style={{ marginRight: "5px" }}>
							Add New
								</button>
					</div>
					<DataTable
						value={medicine.activeIngredients}
						dataKey='activeIngredientId'
					>
						<Column field="activeIngredientName" header="Name" />
						<Column field="molecularFormula" header="Molecular Formula" />
						<Column field="activeIngredientStrength" header="Quantity"
							body={(rowData, column) =>
								<InputText type="text" placeholder="Enter quantity (50)" value={rowData && rowData.activeIngredientStrength ? rowData.activeIngredientStrength : ''}
									onChange={(e) => this.handleQuantityChange(rowData, e.target, 'activeIngredientStrength')} />
							}
						/>
						<Column field="activeIngredientStrength" header="Unit"
							body={(rowData, column) =>
								<Dropdown
									value={rowData && rowData.activeIngredientUnitType ? rowData.activeIngredientUnitType : -1}
									options={unitTypeDropdown}
									onChange={(e) => this.handleQuantityChange(rowData, e, 'activeIngredientUnitType')}
									scrollHeight='105px'
									style={{ width: '100%' }}
								/>
							}
						/>
						<Column
							header="Actions"
							style={{ textAlign: "center", width: "8em" }}
							body={(rowData, column) =>
								<div>
									<Button
										type="button"
										icon="pi pi-times-circle"
										className="p-button-warning"
										tooltip="Remove"
										tooltipOptions={{ position: 'top' }}
										onClick={() => this.props.removeActiveIngredientClick(rowData.activeIngredientId)}
									/>
								</div>
							}
						/>
					</DataTable>
				</div>
				{/* <div className="p-col-12 p-md-6">
					<label>Inactive Ingredients:</label>
					<div className="mb-2">
						<button
							onClick={() => this.handleInactiveIngredientAddNewClick()}
							className="btn btn-success"
							style={{ marginRight: "5px" }}>
							Add New
								</button>
					</div>
					<DataTable
						value={medicine.inactiveIngredients}
						dataKey='inactiveIngredientId'
					>
						<Column header="Name"
							body={(rowData, column) =>
								rowData && rowData.inactiveIngredientContent && rowData.inactiveIngredientContent.length ?
									rowData.inactiveIngredientContent
										.filter(x => typeof x.name === 'string' && x.name.length > 0)
										.map(r => r.name)
										.join(' / ')
									: null
							} />
						<Column
							header="Actions"
							style={{ textAlign: "center", width: "8em" }}
							body={(rowData, column) =>
								<div>
									<Button
										type="button"
										icon="pi pi-times-circle"
										className="p-button-warning"
										tooltip="Remove"
										tooltipOptions={{ position: 'top' }}
										onClick={() => this.props.removeInactiveIngredientClick(rowData.inactiveIngredientId)}
									/>
								</div>
							}
						/>
					</DataTable>
				</div> */}
				<div className="p-col-12 p-md-6">
					<label>Inactive Ingredients:</label>
					<InputTextarea
						rows={7}
						name="inactiveIngredientsContent"
						style={{ width: '100%' }}
						onChange={(e) => this.props.handleContentChange('inactiveIngredientsContent', e.target['value'])}
						value={this.props.getContentValue("inactiveIngredientsContent")}
					/>
				</div>
			</div>
		)
	}
}

export default MedicineTabBasicInfo;